// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThisWeekCard_tw__pMh02 {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 2rem 2rem;
}
.ThisWeekCard_tw__title__-8c2H {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
  margin-bottom: 1rem;
}
.ThisWeekCard_tw__content__R53vX {
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 2rem;
}
@media only screen and (max-width: 50em) {
  .ThisWeekCard_tw__content__R53vX {
    grid-template-columns: 1fr;
  }
}
.ThisWeekCard_tw__card__4bGVj {
  width: 100%;
  height: 10rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  border-radius: 1rem;
  cursor: pointer;
  border: 1px solid var(--color-grey);
  transition: all 0.4s;
}
.ThisWeekCard_tw__card__4bGVj:hover {
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  transform: translateX(3px) translateY(3px);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-primary-3);
}
.ThisWeekCard_tw__card__text__pAmK5 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
}
.ThisWeekCard_tw__card__title__FWz3S {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.ThisWeekCard_tw__card__value__cPLr\\+ {
  font-weight: 700;
  line-height: 2.2rem;
}
.ThisWeekCard_tw__icon__SIw0o {
  font-size: 2.4rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/ThisWeekCard.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,kBAAA;AADD;AAGC;EACC,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AAFF;AAGE;EALD;IAME,0BAAA;EAAD;AACF;AAGC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,oBAAA;AADF;AAGE;EACC,sCAAA;EACA,2BAAA;EACA,0CAAA;EACA,4CAAA;EACA,wCAAA;AADH;AAIE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AAFH;AAKE;EACC,oCAAA;EACA,mBAAA;AAHH;AAME;EACC,gBAAA;EACA,mBAAA;AAJH;AAQC;EACC,iBAAA;AANF","sourcesContent":["@import '../variables/breakpoints';\n\n.tw {\n\twidth: 100%;\n\tborder-radius: 2rem;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 2rem 2rem;\n\n\t&__title {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tfont-size: var(--default-font-size);\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__content {\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 1rem 2rem;\n\t\t@media only screen and (max-width: $bp-medium) {\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\t}\n\n\t&__card {\n\t\twidth: 100%;\n\t\theight: 10rem;\n\t\tbox-sizing: border-box;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 0 1.5rem;\n\t\tborder-radius: 1rem;\n\t\tcursor: pointer;\n\t\tborder: 1px solid var(--color-grey);\n\t\ttransition: all 0.4s;\n\n\t\t&:hover {\n\t\t\tborder: 2px solid var(--color-primary);\n\t\t\tcolor: var(--color-primary);\n\t\t\ttransform: translateX(3px) translateY(3px);\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t}\n\n\t\t&__text {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 1rem;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t&__title {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tline-height: 1.8rem;\n\t\t}\n\n\t\t&__value {\n\t\t\tfont-weight: 700;\n\t\t\tline-height: 2.2rem;\n\t\t}\n\t}\n\n\t&__icon {\n\t\tfont-size: 2.4rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tw": `ThisWeekCard_tw__pMh02`,
	"tw__title": `ThisWeekCard_tw__title__-8c2H`,
	"tw__content": `ThisWeekCard_tw__content__R53vX`,
	"tw__card": `ThisWeekCard_tw__card__4bGVj`,
	"tw__card__text": `ThisWeekCard_tw__card__text__pAmK5`,
	"tw__card__title": `ThisWeekCard_tw__card__title__FWz3S`,
	"tw__card__value": `ThisWeekCard_tw__card__value__cPLr+`,
	"tw__icon": `ThisWeekCard_tw__icon__SIw0o`
};
export default ___CSS_LOADER_EXPORT___;
